module.exports = __webpack_public_path__ + "img/vertical_4_7_6005.167b67a8.png";